export default "__VITE_ASSET__1d188d7e__"